import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3v18h18V3zm-6 6h-4v2h4v6H9v-2h4v-2H9V7h6v2z"
}), 'Looks5Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Looks5Sharp.js
// module id = 4720
// module chunks = 2